export default __webpack_public_path__ + "static/chidi-onwudike-cea524432a27a06f1dc97260f28b666f.jpg";